export class CheckCurrencyMismatchCallingMethod {
  public static readonly nextMethodCreateSaleOrderLine =
    "nextMethodCreateSaleOrderLine";
  public static readonly nextMethodUpdateSaleOrderLine =
    "nextMethodUpdateSaleOrderLine";
  public static readonly onSubmitMethodCreateSaleOrderLine =
    "onSubmitMethodCreateSaleOrderLine";
  public static readonly onSubmitMethodUpdateSaleOrderLine =
    "onSubmitMethodUpdateSaleOrderLine";
}

export class QuotesCheckCurrencyMismatchCallingMethod {
  public static readonly nextMethodCreateQuoteLine =
    "nextMethodCreateQuoteLine";
  public static readonly nextMethodUpdateQuoteLine =
    "nextMethodUpdateQuoteLine";
  public static readonly onSubmitMethodCreateQuoteLine =
    "onSubmitMethodCreateQuoteLine";
  public static readonly onSubmitMethodUpdateQuoteLine =
    "onSubmitMethodUpdateQuoteLine";
}
